export default __webpack_public_path__ + "static/Dear-Travel-Journal-Pink-ee1462c14116da0149e0702bcccf6211.jpg";